import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "79694a03-a490-4ce9-9935-9b2745e13e25",
    content: "A plastered brick wall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-4-item-1.svg` },
  },
  {
    id: "d0381339-fab6-403c-a4e7-49254887c14e",
    content: "A simple, thin drywall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-4-item-2.svg` },
  },
  {
    id: "5af1463f-e370-4467-abd1-df6e0f206202",
    content: "A more complex, thicker drywall",
    options: { image: `${config.ASSETS_URL}/05/18/task/task-4-item-3.svg` },
  },
];

export const task: Task = {
  id: "f02ac837-d19a-4726-b217-e11cea6aad7e",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 3,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["5af1463f-e370-4467-abd1-df6e0f206202"],
};
